import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ContractForm from "../../components/Contracts/ContractForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ContractsEdit = ({classes, contract, person, uploadConfig, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contracts.edit_contract')}
        />

        <Card>
            <CardContent>
                <ContractForm
                    values={contract}
                    person={person}
                    formUrl={formUrl}
                    uploadConfig={uploadConfig}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default ContractsEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contracts/Edit.jsx